module.exports = __webpack_public_path__ + "assets/contact-form-7.7e39d3cb.svg";